/*
 * I move from wire to application representations of data and back. These
 * functions correspond to LogicalRecord's dehydrate and rehydrate (where they
 * got their names).
 */

import TableColumnMetaStore from "data/meta/TableColumnMetaStore";

export const dehydrateField = (v, t) => {
    if ((v == null)) {
        return null;
    } else if (t === "ASSOCIATION" || t === "FILE") {
        return _.isArray(v) ? v.slice() : v;
    } else if (t === "DECIMAL") {
        // todo: should already be a string
        return v.toString();
    } else if (t === "DATE") {
        return [
            v.year(),
            v.month() + 1,
            v.date(),
        ];
    } else if (t === "TIME") {
        return [
            v.hours(),
            v.minutes(),
            v.seconds(),
        ];
    } else if (t === "DATETIME") {
        return [
            v.year(),
            v.month() + 1,
            v.date(),
            v.hours(),
            v.minutes(),
            v.seconds(),
        ];
    } else if (t === "TZTIMESTAMP") {
        return v.valueOf();
    } else if (t === "INTERVAL") {
        const parts = [
            v.years(),
            v.months(),
            v.days(),
            v.hours(),
            v.minutes(),
            v.seconds(),
        ];
        if (parts[0] === 0 && parts[1] === 0 && parts[2] === 0) {
            parts.splice(0, 3);
        }
        return parts;
    } else {
        return v;
    }
};

export const dehydrate = (
    data,
    tableKey,
    columnInfos = TableColumnMetaStore.getAllColumnsByName(tableKey),
) => {
    const result = {};
    for (const n of Object.keys(columnInfos)) {
        result[n] = dehydrateField(data[n], columnInfos[n].type);
    }
    return result;
};

/**
 * I convert from the wire format to data as the application stores it.
 *
 * @param data The wire data to convert
 * @param tableKey The key of the table whose data it is
 * @param columnInfos Optional columnInfo; if omitted it'll be auto-obtained
 */
export const rehydrate = (
    data,
    tableKey,
    includeInverses = false,
    columnInfos = TableColumnMetaStore.getAllColumnsByName(tableKey),
) => {
    let parts;
    const trans = {};
    for (const n of Object.keys(columnInfos)) {
        const info = columnInfos[n];
        if (!includeInverses && info.inverse) continue;
        const t = info.type;
        if (data[n] == null) {
            trans[n] = info.multiValued ? [] : null;
        } else if (t === "ASSOCIATION" || t === "FILE") {
            trans[n] = _.isArray(data[n]) ? data[n].slice() : data[n];
        } else if (t === "DECIMAL") {
            trans[n] = typeof data[n] === "string"
                ? isNaN(parseFloat(data[n])) ? null : data[n]
                : data[n];
        } else if (t === "DATE") {
            parts = [].concat(data[n]);
            parts[1]--;
            // zero-indexed months
            trans[n] = moment(parts);
        } else if (t === "TIME") {
            trans[n] = moment([
                1970,
                0,
                1
            ].concat(data[n]));
        } else if (t === "DATETIME") {
            parts = [].concat(data[n]);
            parts[1]--;
            // zero-indexed months
            trans[n] = moment(parts);
        } else if (t === "TZTIMESTAMP") {
            trans[n] = moment(data[n]);
        } else if (t === "INTERVAL") {
            let s = [].concat(data[n]);
            if (s.length === 7) {
                s[3] += 7 * s[2];
                // move weeks to days
                s.splice(3, 1);
            } else if (s.length === 3) {
                s = [
                    0,
                    0,
                    0
                ].concat(s);
            }
            // add date parts
            while (s.length < 6) {
                s.push(0);
            }
            trans[n] = moment.duration({
                years: s[0],
                months: s[1],
                days: s[2],
                hours: s[3],
                minutes: s[4],
                seconds: s[5]});
        } else {
            trans[n] = data[n];
        }
    }
    return trans;
};




// WEBPACK FOOTER //
// ./app/data/util/hydration.js